import React from 'react';

export const RefreshCountsContext = React.createContext({
  refreshKey: 0,
  refreshCounts: () => console.warn("RefreshCountsProvider no está instalado")
});

export function RefreshCountsProvider({ children }) {
  const [refreshKey, setRefreshKey] = React.useState(0);

  const refreshCounts = React.useCallback(() => {
    setRefreshKey(prev => prev + 1);
  }, []);

  return (
    <RefreshCountsContext.Provider value={{ refreshKey, refreshCounts }}>
      {children}
    </RefreshCountsContext.Provider>
  );
}

export default RefreshCountsContext;